/* eslint-disable */
import { LazyAnimejs } from '@/utils/Controllers/LazyAnimejsController';
import LazySwiperController from '@/utils/Controllers/LazySwiperController';

export const initTabs = (disableSwiper = false) => {
  class Tab {
    constructor(el) {
      this.DOM = { el };
      this.DOM.tabs = this.DOM.el.getElementsByClassName('dln-tabs__item');
      this.DOM.tabButtons = this.DOM.el.getElementsByClassName('dln-tabs__btn');
      this.DOM.currentLine = this.DOM.el.getElementsByClassName(
        'dln-tabs__currentLine',
      )[0];
      this.DOM.tabGradients = this.DOM.el.getElementsByClassName(
        'dln-tabs__gradient',
      );
      this.DOM.currentTab;

      this.DOM.observerLastTarget = this.DOM.tabs[this.DOM.tabs.length - 1];
      this.DOM.observerFirstTarget = this.DOM.tabs[0];
      this.DOM.observer = new IntersectionObserver(this.callback.bind(this), {
        threshold: 0.9,
      });

      this.DOM.observer.observe(this.DOM.observerLastTarget);
      this.DOM.observer.observe(this.DOM.observerFirstTarget);

      this.handleCurrentLine();
      this.initEventListener();
      this.initTabContent();

      this.initTabSlider();
    }

    //
    // ─── TAB MANAGEMENT ──────────────────────────────────────────────
    //

    async initTabSlider() {
      if (!disableSwiper) {
        const LazySwiperLib = await LazySwiperController();
        new LazySwiperLib(this.DOM.el, {
          slidesPerView: 'auto',
          observer: true,
          observeParents: true,
        });
      }
    }

    handleCurrentLine() {
      this.DOM.currentTab = this.DOM.el.getElementsByClassName(
        'dln-tabs__item--current',
      )[0];
      this.DOM.currentLine.style.width = `${this.DOM.currentTab.offsetWidth}px`;
      this.DOM.currentLine.style.transform = `translateX(${
        this.DOM.currentTab.offsetLeft
      }px)`;
    }

    setCurrentTab() {
      const isCurrent = event.currentTarget.parentElement.classList.contains(
        'dln-tabs__item--current',
      );

      if (!isCurrent) {
        for (let i = 0; i < this.DOM.tabs.length; i++) {
          this.DOM.tabs[i].classList.remove('dln-tabs__item--current');
        }
        event.currentTarget.parentElement.classList.add(
          'dln-tabs__item--current',
        );
        this.handleCurrentLine();
      }
    }

    initEventListener() {
      for (const btn of this.DOM.tabButtons) {
        btn.addEventListener('click', event => {
          this.setCurrentTab();
          const { contentId } = event.currentTarget.dataset;
          if (contentId) {
            this.manageTabs(contentId);
          }
        });
      }
    }

    //
    // ─── TABS CONTENT MANAGEMENT ─────────────────────────────────────────────
    //

    manageTabs(contentId) {
      // const tabsContainer = this.DOM.el.parentElement;
      const tabsContent = document.getElementsByClassName('dln-tabs__content');

      if (tabsContent && tabsContent.length > 0) {
        const currentTabContent = document.querySelector(
          '.dln-tabs__content--current',
        );
        if (currentTabContent && currentTabContent.id !== contentId) {
          currentTabContent.classList.remove('dln-tabs__content--current');
          const newCurrentTab = document.querySelector(`#${contentId}`);
          if (newCurrentTab) {
            newCurrentTab.classList.add('dln-tabs__content--current');
          }
        }
      }
    }

    initTabContent() {
      // const tabsContainer = this.DOM.el.parentElement;
      const tabsContent = document.getElementsByClassName('dln-tabs__content');

      if (tabsContent && tabsContent.length > 0) {
        tabsContent[0].classList.add('dln-tabs__content--current');
        this.DOM.currentLine.style.transform = `translateX(0px)`;
      }
    }

    //
    // ─── GRADIENT MANAGEMENT ─────────────────────────────────────────
    //

    callback(entries, observer) {
      Array.from(entries).forEach(entry => {
        if (entry.target === this.DOM.observerFirstTarget) {
          if (!entry.isIntersecting) {
            this.handleGradient(0, 'add');
          } else {
            this.handleGradient(0, 'remove');
          }
        } else if (entry.target === this.DOM.observerLastTarget) {
          if (entry.isIntersecting) {
            this.handleGradient(1, 'remove');
          } else {
            this.handleGradient(1, 'add');
          }
        }
      });
    }

    handleGradient(gradientTarget, gradientAction) {
      if (gradientAction == 'add') {
        this.DOM.tabGradients[gradientTarget].classList.add('-visible');
      } else if (gradientAction == 'remove') {
        this.DOM.tabGradients[gradientTarget].classList.remove('-visible');
      }
    }
  }

  Array.from(document.querySelectorAll('.dln-tabs')).forEach(
    tab => new Tab(tab),
  );
};

export const setActiveContents = classEntry => {
  const contentELs = document.querySelectorAll('.dln-tabs__content');
  Array.from(contentELs).forEach(contentEL => {
    const isActiveTab = contentEL.classList.contains(classEntry);
    contentEL.style.display = isActiveTab ? 'block' : 'none';
    contentEL.classList[isActiveTab ? 'add' : 'remove'](
      'dln-tabs__content--current',
    );
    contentEL.style.opacity = 0;
    if (isActiveTab) {
      setTimeout(async () => {
        const anime = await LazyAnimejs();
        anime({
          targets: contentEL,
          opacity: [0, 1],
          duration: 300,
          easing: 'easeInOutQuad',
        });
      }, 300);
    }
  });
};
